import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Statistic, Table, Button } from "antd";
import voucherApi from "../../../api/voucherApi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

function VoucherStats() {
    const navigate = useNavigate();
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchStats();
    }, []);

    const fetchStats = async () => {
        try {
            setLoading(true);
            const { data } = await voucherApi.getVoucherStats();
            setStats(data.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className="p-6">Đang tải...</div>;
    }

    if (!stats) {
        return null;
    }

    return (
        <div className="p-6">
            <div className="flex items-center gap-4 mb-4">
                <Button icon={<FontAwesomeIcon icon={faArrowLeft} />} onClick={() => navigate("/voucher")}>
                    Quay lại
                </Button>
                <h1 className="text-2xl font-bold">Thống kê Voucher</h1>
            </div>

            <div className="grid grid-cols-3 gap-4 mb-6">
                <Card>
                    <Statistic title="Tổng voucher" value={stats.total} />
                </Card>
                <Card>
                    <Statistic title="Đang hoạt động" value={stats.active} valueStyle={{ color: "#3f8600" }} />
                </Card>
                <Card>
                    <Statistic title="Đã đổi" value={stats.taken} valueStyle={{ color: "#1890ff" }} />
                </Card>
                <Card>
                    <Statistic title="Chờ duyệt" value={stats.pending} valueStyle={{ color: "#faad14" }} />
                </Card>
                <Card>
                    <Statistic title="Hết hạn" value={stats.expired} valueStyle={{ color: "#cf1322" }} />
                </Card>
                <Card>
                    <Statistic title="Hết hàng" value={stats.outOfStock} valueStyle={{ color: "#cf1322" }} />
                </Card>
            </div>

            <div className="grid grid-cols-2 gap-4">
                <Card title="Thống kê theo đối tác">
                    <Table
                        dataSource={stats.byPartner}
                        columns={[
                            { title: "Đối tác", dataIndex: "partner", key: "partner" },
                            { title: "Số lượng", dataIndex: "count", key: "count" },
                            { title: "Tổng giá trị", dataIndex: "totalValue", key: "totalValue", render: (val) => val ? `${parseInt(val).toLocaleString("vi-VN")}đ` : "-" },
                        ]}
                        pagination={false}
                        rowKey="partner"
                    />
                </Card>
                <Card title="Thống kê theo mệnh giá">
                    <Table
                        dataSource={stats.byValue}
                        columns={[
                            { title: "Mệnh giá", dataIndex: "value", key: "value", render: (val) => `${val.toLocaleString("vi-VN")}đ` },
                            { title: "Số lượng", dataIndex: "count", key: "count" },
                        ]}
                        pagination={false}
                        rowKey="value"
                    />
                </Card>
            </div>
        </div>
    );
}

export default VoucherStats;

